/* eslint-disable */
<template>
  <q-page padding >
    <q-card class="my-card" style="width:100%">
      <q-card-section>
        <div class="q-pa-md row" style="width:100%" >
          <div class="col">
            <div class="row">
              <div style="width: 100px; line-height: 44px; text-align: center;">Manufacturer</div>
              <q-select :rules="[myRule]" style="width:180px; " outlined v-model="productManufacturer" :options="Object.keys(productDetailsList)" @input="productBrand=''"  dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />
            </div>
            <div class="row">
              <div style="width: 100px; line-height: 44px; text-align: center;">Brand</div>
              <q-select :rules="[myRule]" style="width:180px; " outlined v-model="productBrand" :options="Object.keys(productDetailsList[productManufacturer]||{})"  @input="productMaterial=''" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />
            </div>
          </div>
          <q-separator spaced inset vertical />
          <div class="col"  style="width:100%">
            <div class="row" >
              <div style="width:200px" class="center">
                <q-uploader ref="coloursUploader" hide-upload-btn @added="xlsxUploader" :max-files="1" label="Upload Order Form" accept=".xlsx" >
                  <template v-slot:header="scope">
                    <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                      <div class="col">
                          <div class="q-uploader__title">Upload Order Form</div>
                          <div class="q-uploader__subtitle">File format: .xlsx</div>
                      </div>
                      <q-btn v-if="scope.canAddFiles" type="a" icon="add_box" round dense flat>
                      <q-uploader-add-trigger />
                      <q-tooltip>Select Files</q-tooltip>
                      </q-btn>
                    </div>
                  </template>
                  <template v-slot:list="scope">
                      <q-list separator>
                          <q-item v-for="file in scope.files" :key="file.name">
                              <q-item-section style="max-width:35px">
                                  <q-icon color="green" size="md" name="done" v-if="fileProcess.status == 'Done'"/>
                                  <q-icon color="red" size="md" name="report_problem" v-if="fileProcess.status == 'Error'"/>
                                  <q-icon color="blue" size="md" name="file_upload" v-if="fileProcess.status == 'Loading'"/>
                              </q-item-section>
                              <q-item-section>
                                  <q-item-label class="full-width text-bold"> {{ setFilename(file.name) }} </q-item-label>
                              </q-item-section>
                              <q-item-section top side>
                                  <q-btn class="gt-xs" size="12px" flat dense round icon="delete" @click="resetFilePicker(file,scope.removeFile)" />
                              </q-item-section>
                          </q-item>
                          <q-banner inline-actions class="text-white bg-red" v-if="fileProcess.status == 'Error'"> {{fileProcess.errorMessage}} </q-banner>
                          <q-inner-loading :showing="fileProcess.loading">
                              <q-spinner size="40px" color="primary" />
                          </q-inner-loading>
                      </q-list>
                  </template> 
                </q-uploader>   
              </div>
            </div>             
          </div>
          
        </div> 
      </q-card-section>
      <q-card-section>
        <q-btn color="primary" label="STEP 1 (LOAD G.O)" @click="getGroupOrder" />
        <q-btn color="primary" label="STEP 2 (SELECT SHEET)" @click="process1" />
      </q-card-section>
    </q-card>    

    Hi There

    {{sheets}}
    
  </q-page>
</template>

<script>
/* eslint-disable */

import gql from 'graphql-tag'
import _ from 'lodash';
import Excel from 'exceljs';


export default {
  name: 'GenerateOrders',
  apollo: {
  },  
  data (){
      return {
        mappedBO:{},
        sheets:[],
        filename:"",
        fileProcess:{status:"Loading",loading:false,errorMessage:""},
        productManufacturer:"",
        productBrand:"",
        brandOrders:"",
        productMaterial:"",
        productDetailsList:{
            "360":{
              "360":["PU","Fiberglass"],
              "Simpl":["Wood"]},
            "Aragon":{
              "Flathold":["PU"], 
              "Grizzly":["PU"],
              "Kilter":["PU"],
              "Kingdom":["PU"],
              "Urban Plastix":["PU"],
              "Working Class":["PU"]},
            "BlocSyndicate":{
              "Satellite":["PU"]},
            "Composite X":{
              "AIX":["Fiberglass","PE","PU","Wood"], 
              "Cheeta":["Dannomond","Fiberglass","Wood"], 
              "Flathold":["Dannomond","Fiberglass"], 
              "Kilter":["Dannomond"], 
              "Kingdom":["Dannomond"], 
              "Urban Plastix":["Dannomond"], 
              "Walltopia":["Fiberglass"], 
              "Working Class":["PE"]},
            "Dimension":{
              "Dimension":["Wood"]},
            "Tack Composites":{
              "Elevation":["Fiberglass"]},
            "Tension":{
              "Tension":["Wood"]},
            "Under Blue Hold":{
              "Under Blue Hold":["Dannomond","Wood"]}
        },        
    }
  },
  computed: {
  },
  methods: {
    async process1(){
        
      for(let order in this.mappedBO){
        let brandOrder = this.mappedBO[order]
        console.log('bo',brandOrder);
        for(let sheet in brandOrder.itemsPerSheet){
          console.log(this.sheets,sheet);     
          if(this.sheets.includes(sheet)){
            //load sheet
            this.setSheetToUse(sheet)
            console.log('this.worksheet',this.worksheet);
                await this.workbook.xlsx.writeFile("test123.xlxs");

            
          }else{
            console.log(`Sheet: "${sheet}" not found in file "${this.filename}"`);
          }    
        }

      }
      

    },
    setFilename(filename){
      this.filename = filename;
      return filename
    },    
    async xlsxUploader(files){
      try{ 
          this.fileProcess.status = "Loading";
          this.fileProcess.loading = true;
          this.sheets = []
          this.filename = files[0]

          this.workbook = new Excel.Workbook(); 
          await this.workbook.xlsx.load(this.filename).then(async(r) =>{
            let sheets = this.listWorksheet(this.workbook);
            console.log('sheets:',sheets);
            
            sheets.forEach(sheet => {
              this.sheets.push(sheet.name)
            });

            this.showSheetSelector = true;
            this.fileProcess.status = "Done"
            this.fileProcess.loading = false;
          })
      }catch(error){
          this.fileProcess.status = "Error"
          this.fileProcess.loading = false;
          this.fileProcess.errorMessage = error   ;
      }
    },
    listWorksheet(workbook,showAll = false){
      let worksheetList = []
      workbook.eachSheet(function(worksheet, sheetId) {
          if(showAll){
            worksheetList.push({name:worksheet.name,id:worksheet.id,orderNo:worksheet.orderNo,state:worksheet.state})
          }else{
            if(worksheet.state == "visible")
                worksheetList.push({name:worksheet.name,id:worksheet.id,orderNo:worksheet.orderNo,state:worksheet.state})
          }
      });
      return worksheetList;
    },
    resetFilePicker(file,removeFileFn){
        removeFileFn(file);
        this.filename = "";
        this.showSheetSelector = false;
        this.enableToStep2 = false;
        this.sheets = []
        this.sheetSelected = ""
        this.fileProcess = {status:"Loading",loading:false,errorMessage:""}
    },        
    myRule (val) {
      if (!val) {
        return 'Required'         
      }
    },
    setSheetToUse(sheetName){
        try{
          this.worksheet = this.workbook.getWorksheet(sheetName);
          this.worksheet.eachRow((row,rowNumber)=>{
            if(row.hidden){
              this.hiddenRows.push(rowNumber)
            }
          })

          this.enableToStep2 = true;
          this.showAttributesList = true;
        }catch(error){
          this.showAttributesList = false;
          this.enableToStep2 = false;
          this.sheetSelected = ""
          console.log('Error selecting XLSX sheet:',sheetName,error)
        }
    },        
    async getGroupOrder(){
      let id = "61b6bacc99f33adc096ffc29"
      let result  = await this.groupOrder_query(id);
      this.brandOrders = result.brandOrders


      for(let brandOrder of this.brandOrders){
        console.log("BO",brandOrder)

        let skus = []
        let notOnMap = []
        let itemsPerSheet = {}
        let items = {}

        let details = {}
        let filter = brandOrder.filter.split("\n")
        for(let item of filter){
          let terms = item.split(":")
          details[terms[0].trim()] = terms[1].trim()
        }


        if(details.manufacturer == this.productManufacturer && details.brand == this.productBrand){
          this.mappedBO[brandOrder.orderNumber] = {}
          let currentMappedBO = this.mappedBO[brandOrder.orderNumber]           
          //Create List of SKU Items
          for(let item of brandOrder.items){
            skus.push(item.sku.id)
            items[item.sku.id] = {product:item.sku.product,qty:item.qty,colour:item.sku.options.colour}
          }
          //Get locations
          let locations = await this.getSkuLocations(skus);

          //Sort locations
          for(let id in locations){
            if(locations[id]){
              let itemLocation = locations[id]
              if(!itemsPerSheet[itemLocation.sheet]){
                itemsPerSheet[itemLocation.sheet] = []
              }
              itemsPerSheet[itemLocation.sheet].push(itemLocation)
            }else{
              notOnMap.push(id)
            }
          }
          currentMappedBO.items = items
          currentMappedBO.itemsPerSheet = itemsPerSheet
          currentMappedBO.notOnMap = notOnMap
        }
      }
    },
    async getSkuLocations(skuIdList){
      try {
        const result = await this.$apollo.query({
          query: gql`query skuLocations ($skuIdList: [String]) {
            skuLocations (skuIdList:$skuIdList)
          }
        `,
        variables: {
          skuIdList: skuIdList
        },
        fetchPolicy: 'network-only'
        })
        console.log('skuLocation',result.data.skuLocations);
        
        return result.data.skuLocations;
      } catch (error) {
        console.log("skuLocation Error:", error)
        throw new Error(error);    
      }         

    },    
    async groupOrder_query (id) {
      try {
        const result = await this.$apollo.query({
          query: gql`query groupOrder($id: ID!){
            groupOrder (id: $id) {
              id
              name
              notes
              isOpen
              openDate
              closeDate
              customerOrders {
                id
                orderNumber
                name
                notes
                account {
                  id
                  companyName
                }
                placed
                verified
                delivered
                createdAt
                updatedAt
                totalCost
              }
              brandOrders {
                id
                name
                orderNumber
                filter
                totalCost
                submitted
                customerOrder {
                    id
                    orderNumber
                    account {
                      companyName
                      id
                    }
                }
                items {
                  id
                  qty
                  sku {
                    id
                    options
                    product {
                      id
                      attributes
                      name
                      reference
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          id: id
        },        
        fetchPolicy: 'network-only'
        })        
        return result.data.groupOrder;
      } catch (error) {
        console.log("groupOrder Error:", error)
        throw new Error(error);    
      }   
    }        
  }
}
</script>



